import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=1a3c2c02&scoped=true&"
import script from "./UserMenu.vue?vue&type=script&lang=ts&"
export * from "./UserMenu.vue?vue&type=script&lang=ts&"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=1a3c2c02&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c2c02",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixUserAvatar: require('/root/project/frontend/src/components/user/BixUserAvatar.vue').default,BixLink: require('/root/project/frontend/src/components/BixLink.vue').default})
